import { ScrollSpeed } from '../../types/Camera/ScrollSpeed';

export const SpeedController = (props: ScrollSpeed) => {
  return (
    <>
      <div className="my-2 flex w-full flex-row justify-between">
        <button
          id="faster"
          onClick={() => {
            props.setSpeed(props.speed - 6);
          }}
        >
          Faster
        </button>
        <input
          id="speed-slider"
          className="slider scale-[1.5]"
          type="range"
          min="25"
          max="180"
          value={props.speed}
          onChange={(e) => props.setSpeed(parseInt(e.target.value))}
          disabled={props.scrolling}
        />
        <button
          id="slower"
          onClick={() => {
            props.setSpeed(props.speed + 6);
          }}
        >
          Slower
        </button>
      </div>
    </>
  );
};
